import * as React from 'react';
import { Preview } from 'react-dnd-multi-backend';

import DriveItem from '../../../containers/DriveItem';

const generatePreview = ({ item, style }) => {
	const newStyle = {
		...style,
		zIndex: 100,
		width: '100%',
		opacity: 0.95,
	};

	return (
		<div style={newStyle}>
			<DriveItem
				driveItem={item.driveItem}
				showUnreadBadge={false}
				displayType={item.displayType}
				hasActions={false}
				isDragPreview={true}
			/>
		</div>
	);
};

const TouchDragPreview = () => <Preview>{generatePreview}</Preview>;

export default TouchDragPreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/TouchDragPreview/index.tsx